import { blue60 } from '../../../colors/blue';
import { rem } from '../../../utils/rem';
export var MuiFormControl = {
    styleOverrides: {
        root: {
            display: 'flex',
            '&[class*=datePickerPristine]': {
                '& [class*=MuiFormHelperText-root]': {
                    display: 'none',
                },
                '& [class*=Mui-error] [class*=MuiOutlinedInput-notchedOutline]': {
                    borderColor: blue60,
                },
            },
            "& [class*='MuiInputAdornment-root'] [class*='Mui-focusVisible']": {
                boxShadow: "0 0 0 2px ".concat(blue60),
            },
        },
    },
    customOverrides: {
        insets: {
            marginTop: rem(8),
            marginBottom: rem(8),
        },
        topLabelPlacement: {
            flexDirection: 'column',
        },
        leadingLabelPlacement: {
            flexDirection: 'row',
        },
        topLabel: {
            marginBottom: rem(4),
        },
        leadingLabel: {
            marginInlineEnd: rem(24),
        },
        leadingLabelInputField: {
            marginTop: rem(6),
        },
        leadingLabelDisplayField: {
            marginTop: rem(2),
        },
        value: {
            flex: 1,
        },
    },
};
